import { Button } from "@brightagency/headstart-common";
import React from "react";
import { WPPost } from "../../../constants/types";
import { AllPostTypesAcf } from "../../../constants/types/acf";
import { getWpPostUrl } from "../../../utils";
import { SaveItemButton } from "../../atoms/SaveItemButton";
import { Outer, Header, HeaderImage, Content, Title } from "./styled";

interface Props {
    page: WPPost<AllPostTypesAcf>;
}

export const PageCard: React.FC<Props> = ({ page }) => {
    return (
        <Outer>
            <Header>
                <HeaderImage src={page.acf.meta?.hero_image?.url} />
            </Header>
            <Title>{page.title.rendered}</Title>
            <Content>
                <Button size="small" maxWidth={-1} to={getWpPostUrl(page)}>
                    View page
                </Button>
                <SaveItemButton id={page.id} />
            </Content>
        </Outer>
    );
};
